import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Container from "../../shared-components/container/Container";
import HomeCard from "./HomeCard/HomeCard";
import TopCards from "./HomeTopCards/TopCards";
import WelcomeOrange from "./WelcomeOrange/WelcomeOrange";
import WhyOrange from "./WhyOrange/WhyOrange";
import HomeHotOffers from "./HomeHotOffers/HomeHotOffers";
import HomeClientsTestimonials from "./HomeClientsTestimonials/HomeClientsTestimonials";
import { getAllServiceProviders } from "../../actions/serviceProviderActions";
import { USER_REGISTER_RESET } from "../../constants/userConstants";

import "./Home.css";
import StorageJourney from "./StorageJourney/StorageJourney";
import Tutorials from "./Tutorials/Tutorials";
import Learning from "./Learning/Learning";
import StorageListing from "./StorageListing/StorageListing";

const Home = () => {
  const { user } = useSelector((state) => state.userLogin);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({ type: USER_REGISTER_RESET });
    if (user) {
      if (user.service_provider && user.is_provider_verified) {
        // if (user.is_stripe_account_active !== undefined && user.is_stripe_account_active) {
        //   dispatch(getAllServiceProviders());
        //   navigate("/service-provider-dashboard/analytics");
        // } else if (user.is_stripe_account_active !== undefined && !user.is_stripe_account_active) {
        //   navigate("/service-provider-stripe-status");
        // }else {
        //   navigate("/");
        // }
        dispatch(getAllServiceProviders());
        navigate("/service-provider-dashboard/analytics");
      } else if (user.service_provider && !user.is_provider_verified) {
        navigate("/provider-details-verification");
      } else {
        navigate("/");
      }
    }
  }, [user]);

  return (
    <>
      <section 
      style={{backgroundColor:'#ffcc00',
      }}
        // id="showcase-area "
        // // style={{
        // //   minHeight: "80vh",
        // //   background:
        // //     'url("https://www.storemygoods.in/assets/images/change_in_images/self-storage-all.jpg")',
        // //   backgroundPosition: "center",
        // //   backgroundRepeat: "no-repeat",
        // // }}

        // style={{
        //   minHeight: "80vh",
        //   background: 'url("/images/banner-background.jpeg")',
        //   backgroundPosition: "center",
        //   backgroundRepeat: "no-repeat",
        //   backgroundSize: "cover",
        // }}
      >
        <div className="mx-auto" style={{ maxWidth: '1688px'}}>
          <div className="showcase-content" style={{maxWidth: '1688px',backgroundColor:'#ffcc00' ,paddingTop:'35px'}}>
            <div className="px-2 px-md-4 px-lg-5">
              <HomeCard />
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-orange" className="py-5" style={{backgroundColor:'#FFF2C0' }}>
      <div className="px-2 px-md-4 px-lg-5 mx-auto" style={{ maxWidth: '1688px'}}>
          <WelcomeOrange />
        </div>
      </section>

      <section id="storage-journey" className="py-5">
      <div className="px-2 px-md-4 px-lg-5 mx-auto" style={{ maxWidth: '1688px'}}>
          <StorageJourney />
        </div>
      </section>

      <section id="storage-journey" className="py-5">
      <div className="px-2 px-md-4 px-lg-5">
          <StorageListing />
        </div>
      </section>
      
      <section id="why-orange" className="py-5">
      <div className="px-2 px-md-4 px-lg-5 mx-auto" style={{ maxWidth: '1688px'}}>
          <WhyOrange />
        </div>
      </section>

      <section id="some-cards" className="py-5 bg-light">
      <div className="text-center">
      <p className='blueTextColr'
      style={{
        fontSize: '24px',
        fontWeight: 400,
        letterSpacing:'-1px',
        lineHeight:1,
      }}
      >Choosing the right storage unit size can be challenging. </p>
            <p className='a-font sj-heading' style={{color:'#ffcc00'}}>
                {/* Variety of Sizes to
                <span style={{ color: '#FFCC00'}}> Fit Your Requirements.</span> */}
                CONFUSED 
                <span style={{ color: '#000034'}}> About </span>
                What Size 
                <span style={{ color: '#000034'}}> You Need?</span>
            </p>
        </div>
        <div className="px-2 px-md-4 px-lg-5">
        <HomeHotOffers />
        </div>
      </section>
      {/* Client Testimonials */}
      <section id="clients" className="container mt-5 overflow-hidden">
        <p className='blueTextColr sj-heading ' style={{textAlign: 'left'}}>
        Hear from those
        <span style={{color:'#ffcc00'}}> who 
        <br />
        chose us.</span>
        </p>
        <HomeClientsTestimonials />
      </section>
      <section id="learnings" className="py-5">
      <p className='blueTextColr sj-heading ' style={{textAlign: 'center'}}>
          <span style={{ color: '#FFCC00'}}> Popular </span>
          Learnings
        </p>
      <Learning></Learning>
      </section>
      <section id="videos" className="container mt-5">
      <div className="text-center" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
  <p className='blueTextColr sj-heading' style={{ textAlign: 'center' }}>
    Get
    <span style={{ color: '#FFCC00'}}> Smart </span>
    About
    <span style={{ color: '#FFCC00'}}> Storage.</span>
  </p>
  <p 
    className='blueTextColr a-font justify-content-center'
    style={{
      fontSize: '20px',
      fontWeight: 400,
      width:'55%',
      textAlign: 'center',
    }}
  >
    Picking the right space doesn’t have to be a headache. We've got everything you need to know. Check out short reels on our social media and start storing smarter.
  </p>
</div>

        <Tutorials></Tutorials>
      </section>
    </>
  );
};

export default Home;
